import { themeGetParamsURL, ThemeService } from '../Theme/mx-theme.service';
import { ColorService } from '../Theme/color.service';

export async function applyCssVariables(restHost) {
	const http = {
		async get() {
			const result = await fetch(`${restHost}/${themeGetParamsURL}`);
			if (!result.ok && result.status !== 503) {
				throw new Error(result.statusText);
			}
			return await result.json();
		},
	};
	const themeService = new ThemeService(http, new ColorService(), {}, {}, {}, { isAuthenticated: () => false }, {});

	const theme = await themeService.getCurrentTheme();
	themeService.applyCssVariables('login', theme, document);
}
